import React from 'react'
import PropTypes from 'prop-types'

import data from '../../data/story'
import useStore from '../../hooks/useStore'
import { StoryItem, Wrapper } from './Story.styles'
import { withRouter } from 'react-router-dom'

function createMarkup(body) {
  return { __html: body }
}

function Story({ match }) {
  const activeYear = (match.params.year && Number(match.params.year)) || 1940

  const {
    state: { lang }
  } = useStore()

  function isActive(year) {
    return parseInt(year, 10) === parseInt(activeYear, 10)
  }

  return (
    <Wrapper className="story">
      {data.map(({ year, content }) => (
        <StoryItem visible={isActive(year)} key={year}>
          <div
            className="text"
            dangerouslySetInnerHTML={createMarkup(content[lang])}
          />
        </StoryItem>
      ))}
    </Wrapper>
  )
}

Story.propTypes = {
  activeYear: PropTypes.number,
  lang: PropTypes.string,
  match: PropTypes.object
}

export default withRouter(Story)
